import { render, staticRenderFns } from "./CambiarClienteModalComponent.vue?vue&type=template&id=10851ee2&"
import script from "./CambiarClienteModalComponent.vue?vue&type=script&lang=js&"
export * from "./CambiarClienteModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports